// LIBRARIES
import {
  BORDER_RADIUS,
  COLORS,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  MARGIN,
} from "constants/variables";
import styled from "styled-components";

export const CardContainer = styled.div<{
  colSpan: number;
  rowSpan: number;
  isImage?: boolean;
}>`
  grid-column: span ${({ colSpan }) => colSpan};
  grid-row: span ${({ rowSpan }) => rowSpan};
  border-radius: ${BORDER_RADIUS.radius21};
  overflow: hidden;
  background-color: ${COLORS.FaluRed};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${MARGIN.max40};
  position: relative;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CardTitle = styled.div`
  text-align: center;
  max-width: 346px;
`;

export const CardContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  /* gap: ${MARGIN.fix24}; */
  gap: ${({ type }) => (type === "paragraph" ? MARGIN.max6 : MARGIN.fix24)};
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${MARGIN.max4};
`;

export const CardIllustration = styled.img`
  position: absolute;
  top: -107px;
  right: -107px;
  width: 255px;
  height: 255px;
`;

export const MailLink = styled.a`
  color: ${COLORS.Cultured};
  font-family: ${FONT_FAMILY.poppins};
  font-weight: ${FONT_WEIGHT.bold};
  font-size: ${FONT_SIZE.max18};
  cursor: pointer;
`;
